goog.provide('el8.appchart.medsHx.renderer');

goog.require('el8.template.render.medsHx');
goog.require('el8.appchart.medsHx.util');


el8.appchart.medsHx.renderer = function(spec) {
    this._container = spec.container;
    this._drawerContainer = spec.drawerContainer;
    this._isTriggersActive = false;
};

/**
 * Managing triggers
 */
el8.appchart.medsHx.renderer.prototype.isTriggersActive = function() {
    return this._isTriggersActive;
};
el8.appchart.medsHx.renderer.prototype.enableTriggers = function() {
    this._isTriggersActive = true;
};
el8.appchart.medsHx.renderer.prototype.disableTriggers = function() {
    this._isTriggersActive = false;
};


/**
 * Formatting contents
 */
el8.appchart.medsHx.renderer.prototype.highlight = function(arg, noRemove) {
    var itemIds = arg;
    if (!(itemIds instanceof Array)) {
        itemIds = [itemIds];
    }
    if (!noRemove) { this.removeAllHighlight(); }
    for (var i=0; i<itemIds.length; i++) {
        var itemId = itemIds[i];
        var $elt = $('.med-order-item[data-id="'+itemId+'"], .dc-order-item[data-id="'+itemId+'"], .thread-title-item[data-id="'+itemId+'"], .fill-item[data-id="'+itemId+'"]', this._container);
        $elt.addClass(el8.appchart.medsHx.util.SELECTED_CLASS);
        $elt.scrollintoview();
    }
};
el8.appchart.medsHx.renderer.prototype.removeAllHighlight = function() {
    $('.med-order-item, .dc-order-item, .thread-title-item, .fill-item', this._container)
        .removeClass(el8.appchart.medsHx.util.SELECTED_CLASS);
};

/**
 * Helpers for rendering in main dialog
 */
el8.appchart.medsHx.renderer.prototype.refreshThread = function(thread) {
    $('.thread-item[data-id="'+thread.getId()+'"]', this._container).replaceWith(
        this.getThreadContent(thread)
    );
};
el8.appchart.medsHx.renderer.prototype.refreshMedOrder = function(order) {
    $('.med-order-item[data-id="'+order.getId()+'"]', this._container).replaceWith(
        this.getMedOrderContent(order)
    );
};
el8.appchart.medsHx.renderer.prototype.removeThreadById = function(threadId) {
    $('.thread-item[data-id="'+threadId+'"]', this._container).remove();
};
el8.appchart.medsHx.renderer.prototype.getThreadSoyMap = function(thread, noNum) {
    // we have an unknown bug that makes some of the orders in getAllOrders empty;
    // we return null from _getOrderAsSoyMap in that case and want to compact here
    var orders = _.compact(thread.getAllOrders().map(this._getOrderAsSoyMap));

    var threadObj = thread.asSoyMap();
    threadObj['feedItemId'] = thread.getFeedItemId();
    if (thread.isRxDownload() && el8.data.currUser.isPhysician()) {
        threadObj['buttons'] = [
            {name: 'Sign Off', htmlClass: 'acknowledge-trigger'}
        ];
    } else if (el8.ptdata.medOrderFills.threadHasUnsignedFills(thread.getId())) {
        threadObj['buttons'] = [];
        if (el8.data.currUser.isPhysician()) {
            threadObj['buttons'].push(
                {name: 'Sign Off', htmlClass: 'acknowledge-trigger'}
            );
        }
        threadObj['buttons'].push(
            {name: 'Actions', htmlClass: 'thread-actions-trigger', hasDropdown: true}
        );
    } else if (thread.isDeleted()) {
        threadObj['buttons'] = [];
    } else {
        threadObj['buttons'] = [
            {name: 'Actions', htmlClass: 'thread-actions-trigger', hasDropdown: true}
        ];
    }
    return {
        thread : threadObj,
        orders : orders,
        num : noNum ? null : el8.ptdata.medOrderThreads.getCategoryRank(thread)
    };
};
el8.appchart.medsHx.renderer.prototype.getThreadContent = function(thread) {
    return el8.template.render.medsHx.thread(this.getThreadSoyMap(thread));
};
el8.appchart.medsHx.renderer.prototype.getMedOrderContent = function(order) {
    return el8.template.render.medsHx.medOrderContent(this._getOrderAsSoyMap(order));
};
el8.appchart.medsHx.renderer.prototype._getOrderAsSoyMap = function(order) {
    if (!order) { return null; }
    var orderObj = order.asSoyMap();
    orderObj['isPrescription'] = order.is('MedOrder');
    return orderObj;
};
el8.appchart.medsHx.renderer.prototype.getThreadTitle = function(thread) {
    if (thread.isActive()) {
        if (thread.isCanceled()) {
            return 'Script(s) Canceled';
        } else if (thread.isPermanent()) {
            if (thread.getLatestOrder().isPrescription()) {
                return 'Permanent Rx Meds';
            } else {
                return 'Permanent OTC Meds';
            }
        } else {
            return 'Temporary Meds';
        }
    } else {
        return 'Discontinued Meds';
    }
};
el8.appchart.medsHx.renderer.prototype.removeFillById = function(fillId) {

    var $fillItem = $('.fill-item[data-id="'+fillId+'"]', this._container);
    var $orderItem = $fillItem.closest('.med-order-item');
    $fillItem.remove();

    // Check to see if any fill items left, or if we should just hide this area
    if (!$('.fill-item', $orderItem).length) {
        $('.fill-content', $orderItem).remove();
    }
};


